/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createTag } from '../fn/tag/create-tag';
import { CreateTag$Params } from '../fn/tag/create-tag';
import { deleteTaq } from '../fn/tag/delete-taq';
import { DeleteTaq$Params } from '../fn/tag/delete-taq';
import { getTag } from '../fn/tag/get-tag';
import { GetTag$Params } from '../fn/tag/get-tag';
import { getTags } from '../fn/tag/get-tags';
import { GetTags$Params } from '../fn/tag/get-tags';
import { Tag } from '../models/tag';
import { TagPagedData } from '../models/tag-paged-data';
import { updateTag } from '../fn/tag/update-tag';
import { UpdateTag$Params } from '../fn/tag/update-tag';

@Injectable({ providedIn: 'root' })
export class TagService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTags()` */
  static readonly GetTagsPath = '/tag';

  /**
   * Gets all tags [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTags$Response(params?: GetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<TagPagedData>> {
    const obs = getTags(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all tags [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTags(params?: GetTags$Params, context?: HttpContext): Observable<TagPagedData> {
    const resp = this.getTags$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TagPagedData>): TagPagedData => r.body)
    );
  }

  /** Path part for operation `createTag()` */
  static readonly CreateTagPath = '/tag';

  /**
   * Creates a new tag [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTag()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTag$Response(params?: CreateTag$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
    const obs = createTag(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new tag [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTag$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTag(params?: CreateTag$Params, context?: HttpContext): Observable<Tag> {
    const resp = this.createTag$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Tag>): Tag => r.body)
    );
  }

  /** Path part for operation `getTag()` */
  static readonly GetTagPath = '/tag/{id}';

  /**
   * Gets the specified tag [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTag$Response(params: GetTag$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
    const obs = getTag(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified tag [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTag(params: GetTag$Params, context?: HttpContext): Observable<Tag> {
    const resp = this.getTag$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Tag>): Tag => r.body)
    );
  }

  /** Path part for operation `updateTag()` */
  static readonly UpdateTagPath = '/tag/{id}';

  /**
   * Updates the specified tag [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTag()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTag$Response(params: UpdateTag$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
    const obs = updateTag(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified tag [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTag$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTag(params: UpdateTag$Params, context?: HttpContext): Observable<Tag> {
    const resp = this.updateTag$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Tag>): Tag => r.body)
    );
  }

  /** Path part for operation `deleteTaq()` */
  static readonly DeleteTaqPath = '/tag/{id}';

  /**
   * Deletes the specified tag [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTaq()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTaq$Response(params: DeleteTaq$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteTaq(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified tag [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTaq$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTaq(params: DeleteTaq$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteTaq$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
